// The HomePageHeroBannerTastic component is a wrapper that renders a hero banner on the homepage.
// It receives structured data via the data prop, extracts herocontent, and passes it to the
// HomePageHeroBanner component for display. This setup allows the banner to dynamically render
// content such as images, videos, or text based on the provided data source.
// It is commonly used to present visually engaging, customizable hero sections on the homepage

'use client';

import React from 'react';
import { TasticProps } from '../types';
import { DataHomepage, HomepageHeroBannerPayload } from 'types/next';
import HomePageHeroBanner from 'components/commercetools-ui/organisms/homepage-hero-banner';
import HomePageBanner from 'components/commercetools-ui/organisms/homepage-hero-banner/homePageBanner';

const HomePageHeroBannerTastic = (data: DataHomepage) => {
  // const herocontent = data?.data?.dataSource;
  return (
    <>
      <head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify((data as any)?.seoStructureData) }}
        />
      </head>
      {/* <HomePageHeroBanner heroContent={herocontent} /> */}
      <HomePageBanner bannerData={data} />
    </>
  );
};

export default HomePageHeroBannerTastic;
